import { MagnifyingGlassIcon as Search } from '@heroicons/react/24/outline';
import Button from 'components/Buttons/Button';
import { useToggleSearchModal } from 'containers/Search/atom';
import React from 'react';
import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

interface Props {
  isOpen: boolean;
}

export function SearchItem({ isOpen }: Props) {
  const { t } = useTranslation(['common']);
  const toggleSearchModal = useToggleSearchModal();
  // navigator.platform is deprecated but ok to use
  // see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/platform#examples
  const ctrlKey = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)
    ? '⌘'
    : 'Ctrl';
  return (
    <Button
      icon={Search}
      large
      onClick={() => toggleSearchModal(true)}
      fill={isOpen}
      alignText="left"
      css={[
        isOpen && tw`px-3!`,
        !isOpen && tw`px-0!`,
        tw`mb-3 border border-reverse-quiet! bg-reverse-quiet text-reverse-quiet hover:bg-reverse-quiet hover:border-brand-moderate!`,
      ]}
    >
      {isOpen && (
        <span tw="w-full flex items-baseline justify-between">
          <span tw="flex-grow mr-3 text-reverse-quiet">
            {t('common:sidebar.search')}
          </span>
          <span tw="hidden lg:block font-bold text-xs whitespace-nowrap bg-reverse-quiet border rounded border-reverse-quiet p-0.5">
            {ctrlKey} K
          </span>
        </span>
      )}
    </Button>
  );
}
